var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-dato-familiar"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v(" Datos familiares")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nombre_completo))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  items.item.parametro_parentesco == null
                                    ? ""
                                    : items.item.parametro_parentesco.valor
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nacionalidad))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$moment(items.item.fecha_nacimiento)
                                    .format("DD/MM/YYYY")
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _vm.estado == 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            icon: "",
                                            color: "primary"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.crearActualizarDatoFamiliar(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Editar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estado == 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "red",
                                            dark: "",
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItem(
                                                items.item.id,
                                                "datoFamiliar"
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "dark" } },
                                            [_vm._v("delete")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Eliminar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _vm.estado == 1
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    color: "primary",
                                    dark: ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.crearActualizarDatoFamiliar({})
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("add")
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.$t("common.add")))
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar Dato familiar")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a38383e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a38383e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/DatosFamiliares.vue
// module id = null
// module chunks = 